<template>
    <vs-row>
        <vs-col vs-lg="3" vs-xs="12">
            <vs-card>
                <h4 class="mb-1">145</h4>
                <span>Уникальные источники</span>
                <vs-progress :percent="70" color="primary">Количество уникальных источников, содержащих сообщения по данной теме</vs-progress>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="3" vs-xs="12">
            <vs-card>
                <h4 class="mb-1" v-if="cor.cases">{{(cor.cases).toLocaleString()}}</h4>
                <span>Заражено коронавирусом</span>
                <vs-progress :percent="10" color="warning">primary</vs-progress>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="3" vs-xs="12">
            <vs-card>
                <h4 class="mb-1" v-if="cor.deaths">{{(cor.deaths).toLocaleString()}}</h4>
                <span>Смертей</span>
                <vs-progress :percent="10" color="danger">primary</vs-progress>
            </vs-card>
        </vs-col>
        <vs-col vs-lg="3" vs-xs="12">
            <vs-card>
                <h4 class="mb-1" v-if="cor.recovered">{{(cor.recovered).toLocaleString()}}</h4>
                <span>Выздоровили</span>
                <vs-progress :percent="90" color="success">primary</vs-progress>
            </vs-card>
        </vs-col>
    </vs-row>    
</template>
<script>
import axios from 'axios';
export default {
    name: "States",
    data() {
    return {
      cor:[]
    }
  },
  created(){
    axios.get('https://coronavirus-19-api.herokuapp.com/all').then(({data})=>{
      this.cor = data;
    })
  }
}
</script>
